import { computed } from 'vue'
import { createSharedComposable } from '@vueuse/core'
import { useQuery } from '@tanstack/vue-query'
import { session } from '@/composables/useSession'
import { hasAccountRole, hasHighestWorkspaceRole } from '@/utils/roleUtils'
import { getUserCount } from '@/modules/user-management/api'
import { getUserGroupsCount } from '@/modules/user-management/groups/api'
import { getBots } from '@/modules/user-management/bots/api'

const _useNavigationBadgeCounts = () => {
  const { data: userCount, isLoading: isLoadingUsers } = useQuery({
    queryKey: ['navigation-badge-users'],
    queryFn: getUserCount,
    enabled: hasAccountRole('ADMIN', 'MANAGER') || hasHighestWorkspaceRole('MANAGER'),
  })

  const { data: groupsCountData, isLoading: isLoadingGroups } = useQuery({
    queryKey: ['navigation-badge-groups'],
    queryFn: () => getUserGroupsCount(),
    enabled: hasAccountRole('ADMIN', 'MANAGER') || hasHighestWorkspaceRole('MANAGER', 'LEAD'),
  })

  const { data: botsData, isLoading: isLoadingBots } = useQuery({
    queryKey: ['bots', []], // Match useBots queryKey
    queryFn: () => getBots([]),
    enabled: session.features.botQa && (hasAccountRole('ADMIN', 'MANAGER') || hasHighestWorkspaceRole('MANAGER')),
  })

  const usersBadge = computed(() => userCount.value ?? undefined)
  const groupsBadge = computed(() => groupsCountData.value?.count ?? undefined)
  const botsBadge = computed(() => botsData.value?.bots?.length ?? undefined)

  const isLoading = computed(() => isLoadingUsers.value || isLoadingGroups.value || isLoadingBots.value)

  return {
    usersBadge,
    groupsBadge,
    botsBadge,
    isLoading,
  }
}

export const useNavigationBadgeCounts = createSharedComposable(_useNavigationBadgeCounts)
